import React from 'react';

import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import {useComponent} from './hooks';

import './SearchSubmitButtonField.less';

function SearchSubmitButtonField() {
    const {
        Button,
        className,
        type,
        label,
        disabled,
        loading,
        onClick
    } = useComponent();

    return (
        <div className={className}>
            <Button
                type={type}
                label={label}
                disabled={disabled}
                onClick={onClick}
            >
                <LoadingOverlay loading={loading}/>
            </Button>
        </div>
    );
}

export {SearchSubmitButtonField};
